import { gql } from '@apollo/client';
import { apolloClient } from 'apollo-client';

export const FETCH_LMI_PROOF_DOC_LABEL_OPTIONS = gql`
  query FetchLmiProofDocLabelOptions(
    $utilityId: Int!
    $productId: String
    $category: String!
  ) {
    lmiProofDocLabelOptions(
      utilityId: $utilityId
      productId: $productId
      category: $category
    ) {
      data
    }
  }
`;

export type Category = 'proof_docs' | 'qualifying_programs';

export interface FetchLmiProofDocLabelOptionsParams {
  utilityId: number;
  productId?: string;
  category: Category;
}

export interface FetchLmiProofDocLabelOptionsResponse {
  data: Record<string, string | string[]> | null;
}

export const fetchLmiProofDocLabelOptions = async (
  params: FetchLmiProofDocLabelOptionsParams
): Promise<FetchLmiProofDocLabelOptionsResponse> => {
  const { data } = await apolloClient.query({
    query: FETCH_LMI_PROOF_DOC_LABEL_OPTIONS,
    variables: {
      utilityId: params.utilityId,
      productId: params.productId,
      category: params.category,
    },
  });

  return {
    data: data.lmiProofDocLabelOptions?.data || null,
  };
};
